<ng-container *ngIf="!showError && type !== 'comparable'; else comparableLP">
  <ng-container class="panel-top">
    <!-- <div style="padding-top: 15px">
      <a
        *ngIf="pageName === 'monitor'"
        class="panel-companylink"
        href="/company/{{ key }}"
        style="cursor: pointer"
      >
        Return to home
      </a> -->
    <div *ngIf="showReturnToHomeLink.includes(pageName)">
      <a
        routerLink="/company/{{ key }}"
        routerLinkActive="active"
        class="return-link"
        >Return to home</a
      >
    </div>
    <app-lineitem-search
      [ticker]="key"
      *ngIf="type === 'company' && isCompanyCovered"
      (callback)="onLineitemChange($event[0])"
      (onClickTabName)="redirectToTab($event)"
      lineItemInputId="leftPanelLineItemInput"
    ></app-lineitem-search>
    <div class="industry-name" *ngIf="type === 'industry'">
      <div>
        <va-icon [name]="faHome" isFontAwesome="true"></va-icon
        ><a routerLink="/sectors_industries" class="sector-label"
          >Sector & Industries</a
        >
      </div>
    </div>
  </ng-container>

  <ul
    class="panel-menu"
    nz-menu
    nzMode="inline"
    [ngClass]="{ chartsLP: pageName === 'charts' }"
  >
    <ng-container *ngIf="loading">
      <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]">
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ng-container>
    <ng-container *ngIf="!loading">
      <!-- shortcuts-section -->
      <div class="shortcuts-section">
        <li
          *ngIf="
            (panelData.extras && panelData.extras.isCoveredCompany === true) ||
            type === 'industry'
          "
          class="group-name"
          nz-submenu
          [nzTitle]="'Shortcuts'"
          [nzOpen]="true"
          (nzOpenChange)="onMenuExpandStateChange('Shortcuts', $event)"
        >
          <ul>
            <!-- Industry Specific -->
            <li
              (click)="onClickIndustryHomeTable(key)"
              *ngIf="type === 'industry'"
              class="group-child"
              nz-menu-item
            >
              <a>Industry Home</a>
            </li>
            <li
              (click)="onClickCoverage(panelData.data[0].values.sectorName)"
              *ngIf="type === 'industry'"
              class="group-child"
              nz-menu-item
            >
              <a>Coverage</a>
            </li>
            <li
              (click)="onClickIndustryCompTable(key)"
              *ngIf="type === 'industry'"
              class="group-child"
              nz-menu-item
            >
              <a>Industry Comp Table</a>
            </li>
            <li
              (click)="
                onClickComparableAnalysis(
                  panelData.data[0].values.compsTabId,
                  key
                )
              "
              *ngIf="type === 'industry'"
              class="group-child"
              nz-menu-item
              [ngClass]="{
                disabled: !panelData.data[0].values.industryPeerAnalysisEnabled
              }"
            >
              <a>Comparable Analysis</a>
            </li>
            <li
              *ngIf="type === 'company' && panelData.extras.entitled"
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'company'"
            >
              <a routerLink="/company/{{ key }}">Line Item Monitor</a>
            </li>
            <!-- ---------Comparative Analysis --------------->
            <li
              *ngIf="
                type === 'company' &&
                panelData.data[0].values.showComparativeAnalysis
              "
              class="group-child"
              nz-menu-item
              nz-popover
              [nzPopoverContent]="comparativeContentTemplate"
              nzPopoverPlacement="rightTop"
              [(nzPopoverVisible)]="visibleComparativePo"
              (nzPopoverVisible)="changeComparativeAnalysisVisibility($event)"
              [nzPopoverOverlayClassName]="'comparative-analysis-popover'"
            >
              <a
                [ngClass]="{
                  'menu-with-pop-item-active': visibleComparativePo
                }"
                class="menu-with-pop-item"
                >Comparative Analysis
                <va-icon
                  size="small"
                  name="chevron-right"
                  class="menu-with-pop-icon"
                  [ngClass]="{
                    'menu-with-pop-icon-active': visibleComparativePo
                  }"
                ></va-icon>
              </a>
            </li>
            <li
              *ngIf="
                type === 'company' &&
                panelData.data[0].values.showRevisionDashboard
              "
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'revisions'"
            >
              <a routerLink="{{ '/company/' + key + '/revisions' }}"
                >Revisions Analysis</a
              >

              <!-- <a href="{{ legacyUrl }}/revisions/{{ key }}?fromCompany=true"
                >Revisions Analysis</a
              > -->
            </li>
            <li
              *ngIf="
                type === 'company' &&
                panelData.data[0].values.showSurpriseAnalysis
              "
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'surprise'"
            >
              <a routerLink="{{ '/company/' + key + '/surprise' }}"
                >Surprise Analysis</a
              >

              <!-- <a href="{{ legacyUrl }}/surprise/{{ key }}?fromCompany=true"
                >Surprise Analysis</a
              > -->
            </li>
            <li
              *ngIf="pageName === 'charts'"
              [nzSelected]="true"
              class="group-child"
              nz-menu-item
            >
              <a>Charts</a>
            </li>
            <li
              *ngIf="
                type === 'company' &&
                panelData.data[0].values.isSellside == true
              "
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'vsconsensus'"
            >
              <a routerLink="{{ '/company/' + key + '/vsconsensus' }}"
                >VS Consensus</a
              >
              <!-- <a href="{{ legacyUrl }}/vsConsensus/{{ key }}">VS Consensus</a> -->
            </li>
            <!-- ---------NAV --------------->
            <li
              *ngIf="type === 'company' && panelData.data[0].values.showNav"
              class="group-child nav-option"
              nz-menu-item
              [nzSelected]="pageName === 'nav'"
            >
              <a routerLink="{{ '/company/' + key + '/nav' }}">NAV</a>
            </li>
            <!-- ---------Valuation --------------->
            <li
              *ngIf="
                type === 'company' && panelData.data[0].values.showValuation
              "
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'valuation'"
            >
              <a routerLink="{{ '/company/' + key + '/valuation' }}"
                >Valuation</a
              >
            </li>

            <!-- ---------Target Price & Ratings --------------->
            <li
              *ngIf="type === 'company' && panelData.data[0].values.showTpr"
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'tpr'"
            >
              <a routerLink="{{ '/company/' + key + '/tpr' }}"
                >Target Price & Ratings</a
              >
            </li>
            <li
              *ngIf="panelData.data[0].values.hasResearchAccess"
              [nzSelected]="pageName === 'research'"
              class="group-child"
              nz-menu-item
            >
              <a
                routerLink="{{
                  '/research/' +
                    key +
                    '/' +
                    panelData.extras.company_symbology_id
                }}"
                routerLinkActive="active"
                >Research Viewer</a
              >
            </li>
            <li
              *ngIf="events_access === true"
              class="group-child"
              nz-menu-item
              [nzSelected]="pageName === 'events'"
            >
              <a routerLink="{{ '/company/' + key + '/events' }}">Events</a>
            </li>
          </ul>
        </li>

        <ng-template #comparativeContentTemplate>
          <app-comparative-analysis-popover-content
            [comparativeAnalysisPopoverData]="comparativeAnalysisPopoverData"
            [ticker]="key"
          ></app-comparative-analysis-popover-content>
        </ng-template>
      </div>
      <!-- current chart section -->
      <div class="left-panel-new-design" *ngIf="currentChartData !== null">
        <li
          [nzOpen]="true"
          *ngIf="currentChartData !== null"
          class="group-name"
          nz-submenu
          [nzTitle]="'Current Chart'"
        >
          <ul>
            <li *ngIf="currentChartData.name === ''">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </li>
            <li
              *ngIf="currentChartData.name !== ''"
              class="group-child"
              nz-menu-item
              (click)="
                navigateCurrent('/charts/current', currentChartData.params)
              "
              [nzSelected]="
                type === 'charts' &&
                selectedChartId === 'current' &&
                currentChartData.selected
              "
            >
              <a [attr.title]="currentChartData.name" style="cursor: pointer">
                {{ currentChartData.name }}</a
              >
            </li>
          </ul>
        </li>
      </div>
      <!-- Comparative analysis section -->
      <div
        class="custom-analysis-left-panel"
        *ngIf="type === 'comparative_analysis'"
      >
        <div class="custom-analysis">
          <div class="custom-analysis-text">Custom Analysis</div>
          <button
            nz-button
            nzSize="small"
            class="create-new_btn"
            (click)="createNew()"
          >
            <va-icon size="small" name="plus"></va-icon>
            Create New
          </button>
        </div>
        <div class="divider" nz-menu-divider></div>
        <div class="panel-section" *ngIf="currentComparativeData !== null">
          <li
            [nzOpen]="true"
            *ngIf="currentComparativeData !== null"
            class="custom-analysis-headers"
            nz-submenu
            [nzTitle]="'Current Analysis (Unsaved)'"
          >
            <ul>
              <li *ngIf="currentComparativeData.name === ''">
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </li>
              <li
                *ngIf="currentComparativeData.name !== ''"
                class="custom-analysis-options"
                nz-menu-item
                (click)="
                  navigateCurrent(
                    '/comparative-analysis/current',
                    currentComparativeData.params.queryParams
                  )
                "
                [nzSelected]="
                  type === 'comparative_analysis' &&
                  comparativePageType === 'current' &&
                  selectedTabId === null &&
                  currentComparativeData.selected
                "
              >
                {{ currentComparativeData.name }}
                <button
                  (click)="
                    actionOnTemplate('save', currentComparativeData.name)
                  "
                  class="save-icon"
                  title="Save As"
                >
                  <va-icon size="small" name="save"> </va-icon>
                </button>
              </li>
            </ul>
          </li>
        </div>
        <div class="panel-section">
          <li
            [nzOpen]="panelData.data.open"
            class="custom-analysis-headers"
            nz-submenu
            [nzTitle]="panelData.data.header"
            (nzOpenChange)="
              onMenuExpandStateChange(panelData.data.header, $event)
            "
          >
            <ul class="custom-analysis-options-container">
              <ng-container *ngIf="panelData.data.values.length > 0">
                <ng-container *ngFor="let item of panelData.data.values">
                  <li
                    (click)="
                      onClickMenu(panelData.data.view, item, panelData.data)
                    "
                    class="custom-analysis-options"
                    nz-menu-item
                    *ngIf="!item.values"
                    [nzSelected]="
                      !!(selectedTabId && item.tab_id === selectedTabId)
                    "
                  >
                    {{ item.label }}
                    <button
                      nz-dropdown
                      nzTrigger="click"
                      [nzDropdownMenu]="menu"
                      class="three-dots"
                    >
                      <va-icon size="small" name="ellipsis-vertical"> </va-icon>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu nzSelectable>
                        <li
                          nz-menu-item
                          (click)="
                            actionOnTemplate(
                              'duplicate',
                              item.label,
                              item.tab_id
                            )
                          "
                        >
                          Duplicate
                        </li>
                        <li
                          nz-menu-item
                          (click)="
                            actionOnTemplate('rename', item.label, item.tab_id)
                          "
                        >
                          Rename
                        </li>
                        <li
                          nz-menu-item
                          (click)="
                            actionOnTemplate('delete', item.label, item.tab_id)
                          "
                        >
                          Delete
                        </li>
                        <li
                          nz-menu-item
                          (click)="
                            actionOnTemplate('share', item.label, item.tab_id)
                          "
                        >
                          Share
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
          </li>
        </div>
      </div>
      <!-- other than shortcuts-section -->
      <div *ngIf="type !== 'comparative_analysis'">
        <div
          [ngClass]="[
            type === 'watchlist' ||
            type === 'charts' ||
            type === 'industry_metrics'
              ? 'left-panel-new-design'
              : ''
          ]"
          *ngFor="let section of panelData.data; let sectionIndex = index"
        >
          <li
            [nzOpen]="section.open || section.view === pageNavParams.cut"
            *ngIf="
              type !== 'comparable' &&
              (sectionIndex !== 0 || type === 'industry_metrics')
            "
            class="group-name"
            nz-submenu
            [nzTitle]="section.header"
            (nzOpenChange)="onMenuExpandStateChange(section.header, $event)"
          >
            <ul>
              <ng-container *ngIf="section.values.length === 0">
                <li class="empty-li">Empty</li>
              </ng-container>

              <ng-container
                *ngIf="
                  section.values.length > 0 && !isItemGroup(section.values[0])
                "
              >
                <ng-container *ngFor="let item of section.values">
                  <li
                    (click)="onClickMenu(section.view, item, section)"
                    class="group-child"
                    nz-menu-item
                    *ngIf="!item.values"
                    [ngClass]="{ disabled: item.enabled === false }"
                    [nzSelected]="
                      (type === 'watchlist' &&
                        selectedWatchlist &&
                        item.watchlistId === selectedWatchlist.watchlistId) ||
                      (type === 'charts' &&
                        item.chart_id &&
                        item.chart_id + '' === selectedChartId) ||
                      (type === 'charts' &&
                        !item.chart_id &&
                        selectedChartId === 'suggested' &&
                        item.index + '' === suggestedChartIndex) ||
                      (type !== 'watchlist' &&
                        type !== 'charts' &&
                        pageNavParams.cut === section.view &&
                        pageNavParams.pg === item.shortName) ||
                      (type === 'industry_metrics' &&
                        selectedIndustryMetricsMenuItem === item.shortName)
                    "
                  >
                    <a
                      *ngIf="!['NMV', 'STD', 'SCH'].includes(section.view)"
                      [attr.title]="item.label"
                    >
                      {{ item.label }}
                    </a>
                    <a
                      *ngIf="['NMV', 'STD', 'SCH'].includes(section.view)"
                      [attr.title]="item.label"
                      routerLink="/mex/{{ pageNavParams.ticker }}/{{
                        section.view
                      }}/{{ item.shortName }}"
                    >
                      {{ item.label }}
                    </a>
                  </li>
                  <!-- </ng-container> -->
                  <ng-container *ngIf="item.values">
                    <li
                      nz-submenu
                      [nzTitle]="item.header"
                      class="group-child-link"
                      (nzOpenChange)="
                        onMenuExpandStateChange(item.header, $event)
                      "
                    >
                      <ul *ngFor="let itemGroup of item.values">
                        <li
                          [nzSelected]="
                            pageNavParams.cut === section.view &&
                            pageNavParams.pg === itemGroup.shortName
                          "
                          (click)="onClickMenu(section.view, itemGroup, item)"
                          class="group-child-link-child"
                          nz-menu-item
                          [ngClass]="{ disabled: item.enabled === false }"
                        >
                          <a
                            *ngIf="section.view !== 'SCH'"
                            [attr.title]="itemGroup.label"
                            >{{ itemGroup.label }}
                          </a>

                          <a
                            *ngIf="section.view === 'SCH'"
                            routerLink="/mex/{{ pageNavParams.ticker }}/{{
                              section.view
                            }}/{{ itemGroup.shortName }}"
                            [attr.title]="itemGroup.label"
                            >{{ itemGroup.label }}
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ng-container>
                </ng-container>
              </ng-container>

              <ng-container
                *ngIf="
                  section.values.length > 0 && isItemGroup(section.values[0])
                "
              >
                <div *ngFor="let itemGroup of section.values">
                  <li
                    (click)="onClickMenu(section.view, itemGroup, section)"
                    class="group-child"
                    nz-menu-item
                    *ngIf="!itemGroup.values; else headerBlock"
                  >
                    <a [attr.title]="itemGroup.label">{{ itemGroup.label }}</a>
                  </li>
                  <ng-template #headerBlock>
                    <li
                      [nzOpen]="
                        itemGroup.open ||
                        itemGroup.header === pageNavParams.source
                      "
                      nz-submenu
                      [nzTitle]="itemGroup.header"
                      class="group-child-link"
                      (nzOpenChange)="
                        onMenuExpandStateChange(itemGroup.header, $event)
                      "
                    >
                      <ul>
                        <li
                          [nzSelected]="
                            (pageNavParams.pg | fixedDecode) ===
                              item.shortName &&
                            pageNavParams.source === itemGroup.header
                          "
                          (click)="onClickMenu(section.view, item, itemGroup)"
                          class="group-child-link-child"
                          nz-menu-item
                          *ngFor="let item of itemGroup.values"
                        >
                          <a
                            *ngIf="section.view !== 'SAR'"
                            [attr.title]="item.label"
                            >{{ item.label }}</a
                          >
                          <a
                            *ngIf="section.view === 'SAR'"
                            routerLink="/mex/{{ pageNavParams.ticker }}/{{
                              section.view
                            }}/{{ item.shortName }}/{{ itemGroup.header }}"
                            [attr.title]="item.label"
                          >
                            {{ item.label }}
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ng-template>
                </div>
              </ng-container>
            </ul>
          </li>
          <li nz-menu-divider></li>
        </div>
      </div>
    </ng-container>
  </ul>
  <ng-container *ngIf="type === 'company' && !isCompanyCovered && !loading">
    <div class="error-message">
      <p class="error-text">Normalize Forecasts on this company?</p>
      <div *ngIf="normalizeForecastBtnText == 'Prioritize'">
        <button
          nz-button
          nzType="primary"
          id="prioritize"
          (click)="onClickPrioritize()"
        >
          {{ normalizeForecastBtnText }}
        </button>
      </div>
      <div *ngIf="normalizeForecastBtnText != 'Prioritize'">
        <button nz-button nzType="secondary" id="prioritize" disabled>
          {{ normalizeForecastBtnText }}
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>

<!-- Comps Page Left Panel Template -->
<ng-template #comparableLP>
  <ng-container *ngIf="!showError">
    <ng-container class="panel-top">
      <div class="comps-search-container">
        <nz-input-group
          [nzSize]="'small'"
          id="search-input"
          [nzPrefix]="prefixTemplateUser"
        >
          <input
            type="text"
            #search
            class="comps-search-input"
            [formControl]="searchQuery"
            nz-input
            placeholder="Search Table Name"
          />
        </nz-input-group>
        <ng-template #prefixTemplateUser
          ><va-icon
            size="small"
            name="search"
            class="va-icon comps-search-icon"
            style="color: #979797"
          ></va-icon
        ></ng-template>
      </div>
    </ng-container>
    <ul class="panel-menu" nz-menu nzMode="inline">
      <ng-container *ngIf="loading">
        <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </li>
      </ng-container>
      <ng-container *ngIf="!loading">
        <div *ngIf="currentCompData !== null">
          <ul
            [nzOpen]="currentCompData"
            class="group-name comps-group-name"
            nz-submenu
            [nzTitle]="'Current Table'"
          >
            <li *ngIf="currentCompData.name === ''">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </li>
            <li
              *ngIf="currentCompData.name !== ''"
              class="group-child-link-child comps-li"
              nz-menu-item
              style="padding: 0 0; line-height: 22px; height: 22px"
              (click)="
                navigateCurrent('/comptables/current', currentCompData.params)
              "
              [nzSelected]="
                type === 'comparable' &&
                selectedTabId === null &&
                currentCompData.selected
              "
            >
              <a [attr.title]="currentCompData.name" style="cursor: pointer">
                {{ currentCompData.name }}</a
              >
            </li>
          </ul>
        </div>
        <div *ngFor="let section of panelData.data; let sectionIndex = index">
          <ul
            [nzOpen]="section.open"
            class="group-name comps-group-name"
            nz-submenu
            [nzTitle]="section.header"
          >
            <li>
              <ng-container *ngIf="section.values.length === 0">
                <ul>
                  <li class="empty-li">Empty</li>
                </ul>
              </ng-container>
              <ng-container
                *ngTemplateOutlet="
                  recursiveListTmpl;
                  context: {
                    section: section.values,
                    sectionIndex: sectionIndex
                  }
                "
              ></ng-container>
            </li>
          </ul>
        </div>
        <ng-template
          #recursiveListTmpl
          let-section="section"
          let-sectionIndex="sectionIndex"
        >
          <ng-container
            *ngFor="let item of section; let itemIndex = index"
            style="margin-top: 0"
          >
            <ul
              *ngIf="item.values && item.values.length === 0"
              style="margin-top: 0px"
            >
              <li
                class="group-child-link"
                nz-submenu
                [nzOpen]="item.open"
                [nzTitle]="item.label"
                [ngClass]="{ paddingStyle: sectionIndex === 1 }"
              >
                <ul>
                  <li class="empty-li">Empty</li>
                </ul>
              </li>
            </ul>
            <ul
              *ngIf="item && item.values && item.values.length > 0"
              style="margin-top: 0px"
            >
              <li
                class="group-child-link"
                nz-submenu
                [nzOpen]="searchQuery.value !== '' ? true : item.open"
                [nzTitle]="item.label"
                [ngClass]="{
                  paddingStyle:
                    item.values && item.values[0].values === undefined
                }"
                [title]="item.label"
              >
                <ng-container
                  *ngTemplateOutlet="
                    recursiveListTmpl;
                    context: {
                      section: item.values,
                      sectionIndex: sectionIndex
                    }
                  "
                ></ng-container>
              </li>
            </ul>

            <li
              *ngIf="!item.values"
              class="group-child-link-child comps-li"
              nz-menu-item
              style="padding: 0 0; line-height: 22px; height: 22px"
              (click)="navigateComps(item, sectionIndex)"
              [nzSelected]="item.shortName === selectedTabId"
            >
              <a [attr.title]="item.label" style="cursor: pointer">
                {{ item.label }}
              </a>
            </li>
          </ng-container>
        </ng-template>
      </ng-container>
    </ul>
  </ng-container>
</ng-template>

<ng-container *ngIf="showError">
  <div class="error-message">
    <va-icon size="small" name="info-circle" class="info-icon"></va-icon>
    <span class="error-text">Something went wrong here!</span>
  </div>
</ng-container>
